import http from '../http';
import {api} from '../api';
import {
  GetAnalysisByDateBody,
  GetAnalysisByDateResponse,
  GetAnalysisByTabResponse,
  GetAnalysisDetailsResponse,
} from '../../interfaces/api/analysis';
import {store} from '../../redux/store';

export const analysis = {
  getByTab: (
    tabId: number,
    page: number,
    pageSize: number = 20,
  ): Promise<GetAnalysisByTabResponse> =>
    new Promise((resolve, reject) => {
      const url = `${api.analysis.getByTab}?tab_id=${tabId}&page=${page}&pageSize=${pageSize || 20}`;
      http
        .get(url)
        .then(res => resolve(res as GetAnalysisByTabResponse))
        .catch(e => reject(e));
    }),

  getById: (id: number): Promise<GetAnalysisDetailsResponse> =>
    new Promise((resolve, reject) => {
      const url = `${api.analysis.getById}${id}`;
      http
        .get(url)
        .then(res => resolve(res as GetAnalysisDetailsResponse))
        .catch(e => reject(e));
    }),

  getByDate: ({
    tabId,
    dateFrom,
    dateTo,
    page,
    pageSize,
    filters,
  }: GetAnalysisByDateBody): Promise<GetAnalysisByDateResponse> =>
    new Promise((resolve, reject) => {
      const {speciality_id} = store.getState().auth?.currentUser || {};
      const params = new URLSearchParams();
      if (!tabId || !speciality_id) {
        throw new Error('tab id and speciality id are required');
      }
      params.append('tab_id', tabId.toString());
      params.append('speciality_id', speciality_id.toString());
      Object.keys(filters || {}).forEach(key => {
        if (
          filters[key] &&
          (key === 'subspeciality_id' ||
            key === 'type_of_study_id' ||
            key === 'resource_id')
        ) {
          params.append(key, String(filters[key]));
        }
      });
      params.append('dateFrom', dateFrom.toString());
      if (dateTo) {
        params.append('dateTo', dateTo.toString());
      }

      if (page) {
        params.append('page', page.toString());
        params.append('pageSize', (pageSize || 20).toString());
      }
      const url = `${api.analysis.getByDateRange}?${params.toString()}`;
      http
        .get(url)
        .then(res => resolve(res as GetAnalysisByDateResponse))
        .catch(e => reject(e));
    }),
};
